const MITT_NAF_URL =
  typeof window === "undefined" ||
  window.location.origin === "https://skademelding.naf.no"
    ? "https://www.naf.no/mitt-naf"
    : "https://test.naf.no/mitt-naf";
export default MITT_NAF_URL;
